import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@material-ui/core';
import { appTheme } from './theme';
import 'font-awesome/css/font-awesome.min.css'; 
import './i18n';
import AppLoadingComponent from './ui/common/loading/app-loading.component';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<AppLoadingComponent/>}>
      <ThemeProvider theme={appTheme}>
        <App />
      </ThemeProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
